var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { datadogLogs } from '@datadog/browser-logs';
import * as qs from 'qs';
import { addProtocolIfMissing } from '../add-protocol-if-missing';
import { formatUtm } from '../format-utm';
var replaceLTMsWithUTMs = function (payload) {
    return payload.replace(/ltm_(?<verb>(term|campaign|content|source|medium))/gm, 'utm_$<verb>');
};
var parseUTMsFromURLOrPath = function (payload) {
    var parsedPayload = payload.indexOf('utm') === -1 ? replaceLTMsWithUTMs(payload) : payload;
    var parsedQueryString = qs.parse(parsedPayload, { ignoreQueryPrefix: true });
    var parsedUTMs = formatUtm(parsedQueryString);
    var nestedParamsPossible = Boolean(!(parsedUTMs === null || parsedUTMs === void 0 ? void 0 : parsedUTMs.utmSource) && (parsedQueryString === null || parsedQueryString === void 0 ? void 0 : parsedQueryString.returnURL));
    if (nestedParamsPossible) {
        var parsedReturnURLParams = parseUTMsFromURLOrPath(new URL(addProtocolIfMissing(parsedQueryString.returnURL)).search);
        return __assign(__assign({}, parsedUTMs), parsedReturnURLParams);
    }
    return parsedUTMs;
};
var parseUTMsFromCurrentUrl = function () {
    var _a;
    try {
        return parseUTMsFromURLOrPath((_a = location === null || location === void 0 ? void 0 : location.search) !== null && _a !== void 0 ? _a : '');
    }
    catch (error) {
        datadogLogs.logger.error("An error occurred parsing location.search, see errorDetails for more information.", {
            errorDetails: {
                error: error,
                locationSearch: location === null || location === void 0 ? void 0 : location.search
            }
        });
        return {
            utmSource: "",
        };
    }
};
var parseUTMsFromAccountOrigin = function (accountOrigin) {
    try {
        var builtAccountOrigin = new URL(addProtocolIfMissing(accountOrigin));
        return parseUTMsFromURLOrPath(builtAccountOrigin.search);
    }
    catch (error) {
        datadogLogs.logger.error("An error occurred parsing account origin, see errorDetails for more information.", {
            errorDetails: {
                error: error,
                accountOrigin: accountOrigin
            }
        });
        return {
            utmSource: ""
        };
    }
};
export var retrieveUtm = function (accountOrigin) {
    try {
        var currentUrlUTMs = parseUTMsFromCurrentUrl();
        var accountOriginUtms = accountOrigin && parseUTMsFromAccountOrigin(accountOrigin);
        var noUtmSourceFound = !(currentUrlUTMs === null || currentUrlUTMs === void 0 ? void 0 : currentUrlUTMs.utmSource) && !(accountOriginUtms === null || accountOriginUtms === void 0 ? void 0 : accountOriginUtms.utmSource);
        if (noUtmSourceFound)
            return false;
        if (currentUrlUTMs === null || currentUrlUTMs === void 0 ? void 0 : currentUrlUTMs.utmSource)
            return currentUrlUTMs;
        if (accountOriginUtms === null || accountOriginUtms === void 0 ? void 0 : accountOriginUtms.utmSource)
            return accountOriginUtms;
        return false;
    }
    catch (error) {
        datadogLogs.logger.error("An error occurred while attempting to retrieve UTMs.", {}, error);
        return false;
    }
};
//# sourceMappingURL=index.js.map